function Sarah() {
  return <div>THIS is Sarah</div>;
}

export default Sarah;
